// extracted by mini-css-extract-plugin
module.exports = {"key":"Key_key__3UZEJ","natural":"Key_natural__j8IUH","sharp":"Key_sharp__3euE1","is-active":"Key_is-active__3AvtK"};